import { useMemo } from 'react';
import { useNetBenefitData } from '../../hooks/use-net-benefit-data';

export const MIN_ACCEPTABLE_PERCENT = 0.5;

export const useRateValidation = (rate: number) => {
	const { rawCalculatedData } = useNetBenefitData();

	return useMemo(() => {
		// If no data is available, return default values
		if (!rawCalculatedData || rawCalculatedData.length === 0) {
			return {
				isRateTooLow: false,
				rateWarningMessage: null,
				avgForecastedADR: 0,
				recommendedMinRate: 0,
			};
		}

		// Calculate the average forecasted ADR
		const totalRevenue = rawCalculatedData.reduce(
			(sum, entry) => sum + (entry.fcst_rev || 0),
			0,
		);

		const totalSold = rawCalculatedData.reduce(
			(sum, entry) => sum + (entry.total_fcst || 0),
			0,
		);

		const avgForecastedADR = totalSold > 0 ? totalRevenue / totalSold : 0;
		const recommendedMinRate = avgForecastedADR * MIN_ACCEPTABLE_PERCENT;

		// Check if rate is too low (but allow the form to submit)
		const isRateTooLow = rate < recommendedMinRate && avgForecastedADR > 0;
		const message = isRateTooLow
			? `Rate is less than 50% of the average forecasted ADR ($${Math.floor(
					avgForecastedADR,
				)}). Consider at least $${Math.ceil(recommendedMinRate)}.`
			: null;

		return {
			isRateTooLow,
			rateWarningMessage: message,
			avgForecastedADR,
			recommendedMinRate,
		};
	}, [rawCalculatedData, rate]);
};
